import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "image", "title"]

  open(event) {
    const src = event.params.src
    const title = event.params.title || ""

    this.imageTarget.src = src
    this.imageTarget.alt = title
    this.titleTarget.textContent = title
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.imageTarget.src = ""
    document.body.style.overflow = ""
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
